import axiosInstance from "../axiosinstance";

const GROUPS_PER_PAGE = 100;

export const getChatUserOptions = async (projectId = null) => {
  const response = await axiosInstance.get("/api/groups/member-options", {
    params: projectId ? { project_id: projectId } : {},
  });
  return {
    currentUserId: response.data?.current_user_id || "",
    users: response.data?.data || [],
    projects: response.data?.projects || [],
  };
};

export const getAllMyGroups = async () => {
  const groups = [];
  let page = 1;
  let totalPages = 1;

  do {
    const response = await axiosInstance.get("/api/groups", {
      params: { page, per_page: GROUPS_PER_PAGE },
    });
    groups.push(...(response.data?.data || []));
    totalPages = Math.max(1, Number(response.data?.meta?.total_pages) || 1);
    page += 1;
  } while (page <= totalPages);

  return groups;
};

export const getGroup = async (chatGroupId) => {
  const response = await axiosInstance.get(`/api/groups/${chatGroupId}`);
  return response.data;
};

export const getAllGroupMembers = async (chatGroupId) => {
  const members = [];
  let page = 1;
  let totalPages = 1;

  do {
    const response = await axiosInstance.get(
      `/api/groups/${chatGroupId}/members`,
      { params: { page, per_page: GROUPS_PER_PAGE } },
    );
    members.push(...(response.data?.data || []));
    totalPages = Math.max(1, Number(response.data?.meta?.total_pages) || 1);
    page += 1;
  } while (page <= totalPages);

  return members;
};

export const getMessages = async (chatGroupId, cursor = null, limit = 50) => {
  const response = await axiosInstance.get(`/api/groups/${chatGroupId}/messages`, {
    params: { limit, ...(cursor ? { cursor } : {}) },
  });
  return {
    data: response.data?.data || [],
    meta: response.data?.meta || { next_cursor: null, has_more: false },
  };
};

export const sendGroupMessage = async (
  chatGroupId,
  { body, attachments = [], clientMessageId },
) => {
  const formData = new FormData();
  if (body?.trim()) formData.append("body", body.trim());
  formData.append("client_message_id", clientMessageId);
  attachments.forEach((file) => formData.append("attachments", file));
  const response = await axiosInstance.post(
    `/api/groups/${chatGroupId}/messages`,
    formData,
  );
  return response.data;
};

export const markGroupRead = async (chatGroupId, lastReadMessageId) => {
  const response = await axiosInstance.post(`/api/groups/${chatGroupId}/read`, {
    ...(lastReadMessageId ? { last_read_message_id: lastReadMessageId } : {}),
  });
  return response.data;
};

export const createGroup = async (payload) => (await axiosInstance.post("/api/groups", payload)).data;
export const createDirectMessage = async (userId) => (await axiosInstance.post("/api/direct-messages", { user_id: userId })).data;
export const updateGroup = async (id, payload) => (await axiosInstance.patch(`/api/groups/${id}`, payload)).data;
export const archiveGroup = async (id, remark = "") => (await axiosInstance.delete(`/api/groups/${id}`, { data: { remark } })).data;
export const addGroupMembers = async (id, memberIds) => (await axiosInstance.post(`/api/groups/${id}/members`, { member_ids: memberIds })).data;
export const removeGroupMember = async (id, userId) => (await axiosInstance.delete(`/api/groups/${id}/members/${userId}`)).data;
export const leaveGroup = async (id) => (await axiosInstance.post(`/api/groups/${id}/leave`)).data;
export const editGroupMessage = async (groupId, messageId, body) => (await axiosInstance.patch(`/api/groups/${groupId}/messages/${messageId}`, { body })).data;
export const deleteGroupMessage = async (groupId, messageId, remark = "") => (await axiosInstance.delete(`/api/groups/${groupId}/messages/${messageId}`, { data: { remark } })).data;
